export default __webpack_public_path__ + "static/media/calendar-white.95ffd8ef.svg";